module.exports = __webpack_public_path__ + "img/Australia.4824ec00.svg";